/**
 * Filtro de proyectos por nombre para el dashboard del arquitecto.
 * Busca (case-insensitive) en el título externo, el nombre interno y el email
 * del cliente. Extraído para poder testear la lógica sin montar el componente.
 */

export interface FilterableProject {
  externalName?: string | null;
  internalName?: string | null;
  clientEmail?: string | null;
}

export const filterProjectsByName = <T extends FilterableProject>(
  projects: T[],
  searchTerm: string
): T[] => {
  const normalized = searchTerm.trim().toLowerCase();
  if (!normalized) return projects;

  return projects.filter(project =>
    [project.externalName, project.internalName, project.clientEmail].some(field =>
      (field || '').toLowerCase().includes(normalized)
    )
  );
};
